import {UserPermissionValue} from 'types';

const permission = (value: string) => `PERMISSION_${value}` as UserPermissionValue;

export const PERMISSION_ALIASES = {
    profileDataView: permission('MPL_PROFILE_DATA_VIEW'),
    registeredTurnoverParticipantsView: permission('MPL_ISEMT_USER_REG_TURNOVER_PARTICIPANTS_VIEW'),
    organizationRegister: permission('MPL_ISEMT_ORGANIZATION_REGISTER'),
    organizationEdit: permission('MPL_ISEMT_ORGANIZATION_EDIT'),
    allStoragesView: permission('MPL_ISEMT_USER_ALL_VIEW'),
    userOwnStoragesView: permission('MPL_ISEMT_USER_OWN_VIEW'),
    userOwnRegister: permission('MPL_ISEMT_USER_OWN_REGISTER'),
    userAllRegister: permission('MPL_ISEMT_USER_ALL_REGISTER'),
    userOwnEdit: permission('MPL_ISEMT_USER_OWN_EDIT'),
    userAllEdit: permission('MPL_ISEMT_USER_ALL_EDIT'),
    userEmployeeInfoView: permission('MPL_ISEMT_USER_EMPLOYEE_INFO_VIEW'),
    organizationParticipantOwnRegister: permission(
        'MPL_ISEMT_ORGANIZATION_PARTICIPANT_OWN_REGISTER',
    ),
    participantAllRegister: permission('MPL_ISEMT_PARTICIPANT_ALL_REGISTER'),
    participantOwnEdit: permission('MPL_ISEMT_PARTICIPANT_OWN_EDIT'),
} as const;

export type PermissionAlias = keyof typeof PERMISSION_ALIASES;
export type PermissionAliasMap = Record<PermissionAlias, UserPermissionValue>;
